import { Button, Flex, Modal, Row, Space } from "antd";
import { confirmTick } from "../assets";

type ConfirmationProps = {
  image?: string;
  text: string;
  manualClose?: boolean;
};
const successModal = {
  show({ image, text, manualClose }: ConfirmationProps) {
    Modal.info({
      centered: true, // Center the modal
      content: (
        <>
          <Flex justify="center">
            <Space direction="vertical" align="center">
              <img
                src={image || confirmTick}
                alt="icon"
                style={{ width: 50, height: 50 }}
              />
              <h4 style={{ color: "#ffffff", textAlign: "center" }}>{text}</h4>
            </Space>
          </Flex>
          {manualClose ? (
            <Row justify={"center"}>
              <Button
                type="primary"
                ghost
                onClick={() => Modal.destroyAll()}
                style={{
                  borderColor: "#EC171E",
                  color: "#EC171E",
                  marginTop: 20,
                }}
              >
                Close
              </Button>
            </Row>
          ) : null}
        </>
      ),

      styles: {
        content: {
          background:
            "linear-gradient(180deg, #2d2d2d 0%, #232323 100%)",
          border: "1px solid rgba(255,255,255,0.08)",
          borderRadius: 18,
          boxShadow: "0 24px 60px rgba(0,0,0,0.4)",
          padding: "32px 28px",
        },
      },
      icon: null,
      footer: null,
      closable: false,
    });

    if (!manualClose) {
      setTimeout(() => {
        Modal.destroyAll(); // Close all modals
      }, 2000);
    }
  },
};

export default successModal;
